/** Princípio ativo para exibição no receituário impresso. */

export function substanceFromPosologyProfileKey(key: string | null | undefined): string {
  const raw = String(key || '').trim();
  if (!raw) return '';
  return raw.split('|')[0]?.trim() || '';
}

export function resolvePrescriptionActiveIngredient(item: {
  active_ingredient?: string | null;
  posology_profile_key?: string | null;
}): string {
  const fromField = String(item.active_ingredient || '').trim();
  if (fromField) return fromField;
  return substanceFromPosologyProfileKey(item.posology_profile_key);
}

/** Texto em maiúsculas abaixo do nome comercial, quando distinto dele. */
export function formatPrintActiveIngredient(item: {
  medication_name?: string | null;
  active_ingredient?: string | null;
  posology_profile_key?: string | null;
}): string {
  const ingredient = resolvePrescriptionActiveIngredient(item);
  if (!ingredient) return '';
  const name = String(item.medication_name || '').trim();
  if (name && ingredient.localeCompare(name, 'pt-BR', { sensitivity: 'accent' }) === 0) {
    return '';
  }
  return ingredient.toUpperCase();
}
